const regex = {
    signin: {
        emailRegExp: /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9]+)*@[A-Za-z0-9]+([_.][A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
        phoneRegExp: /^[2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6}/,
        regexForDisablingAutoSuggest: /^[\d-\s()]*$/,
    },
    createAccount: {
        firstName: /^(?!.*([A-Za-z0-9 ])\1{2})(?=.*[a-zA-Z])[A-Za-z0-9,. -]{1,17}$/,
        lastName: /^([A-Za-z0-9 ])(?=.*[a-zA-Z])[A-Za-z0-9,. -]{1,22}$/,
        name: /^[a-zA-Z\s0-9]*$/,
        phoneNumberRegx: /^[0-9]*$/,
        phoneMask: /^[0-9 ()+-]*$/,
        onlyNum: /[^\d]/g,
        phoneNumber: /^[0-9]{9,20}$/,
        strictPhoneNumber: /^[2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6}/,
        passwordWithoutJcpKeyWords: /jcp|penney|penny/,
    },
    passwordReset: {
        regexForInvalidSpecials: /^[\^A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~\s]+$/,
        regexForInvalidSpecialsWithoutSpace: /^[\^A-Za-z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/,
    },
    missingPoints: {
        receiptNumber: /^[a-zA-Z\d]+$/,
        totalAmount: /^\d+(?:\.\d{0,2})?$/,
    },
};

export default regex;
